module.exports = __webpack_public_path__ + "img/video-gray.f3288da7.svg";